require('./cardChargeNoOpenYoungAccount.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @components
const WizardError = require('components/commons/wizardError/wizardError');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @constants
const {
    JUNIOR_ACCOUNT_HIRING_INITIATION_POINT
} = require('constants/index');

class CardChargeNoOpenYoungAccount extends React.Component {
    constructor(props) {
        super(props);
        this.handleHireOYAccount = this.handleHireOYAccount.bind(this);
    }

    handleHireOYAccount() {
        this.props.setJuniorAccountHiringInitiationPoint(JUNIOR_ACCOUNT_HIRING_INITIATION_POINT);
        this.props.history.push('/myprofile/purchase/junior-account');
    }

    render() {
        const { immCard } = this.props;
        const title = formatText('moneySavingsRequest-noOYAccountErrorTitle');
        const cardAlias = immCard.getIn(['alias', 'current']);
        const goBackButtonLabel = formatText('moneySavingsRequest-backLink', [cardAlias]).toUpperCase();
        const linkToMovements = `myprofile/global`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToMovements
        }

        const list =  ['openAccountStep', 'acceptMoneyStep', 'makeTransferStep' ];
        const elements = list.map((item, index) => {
            return (
                <li className="card-charge-no-openyoung-account__savingsteps-item" key={`element-${index}`}>
                    <FormattedText
                        value={`moneySavingsRequest-${item}`}
                    />
                </li>
            );
        });

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8 card-charge-no-openyoung-account">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackButton}>
                    <section className="row">
                        <div className="col-xs-5">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>
                        <div className="col-xs-7">
                            <FormattedText value="moneySavingsRequest-noOYAccountErrorMsg" />
                            <ul className="card-charge-no-openyoung-account__savingsteps">
                                {elements}
                            </ul>
                            <div className="card-charge-no-openyoung-account__button">
                                <OKButton
                                    modifier="secondary"
                                    onClick={this.handleHireOYAccount}
                                >
                                    <FormattedText value="moneySavingsRequest-hireOYAccountButtonText" />
                                </OKButton>
                            </div>
                        </div>
                    </section>
                </WizardError>
            </div>
        );
    }
}

CardChargeNoOpenYoungAccount.propTypes = {
    amount: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    setJuniorAccountHiringInitiationPoint: PropTypes.func.isRequired
};

module.exports = withRouter(CardChargeNoOpenYoungAccount);
